export default "__VITE_ASSET__CpH64GRO__"